import React from 'react'

const TeamStandingsTotal = ({total_length,measurement_type,length_measurement_symbol,weight_measurement_symbol}) => {



 
  // Check for the measurement type to show totals
  // Change added on 03-15-2021
  if(measurement_type === 'length'){
    const totalDisplay =  <td style={{textAlign : 'center'}}>
      
       <div className="fish-total">{total_length}{length_measurement_symbol}</div>  


      </td> 
      return(
        <>
        {totalDisplay}
        </>
      )
  }else{

    const totalDisplay = <td style={{textAlign : 'center'}}>
      
      <div className="fish-total">{total_length}{weight_measurement_symbol}</div>  

    

      </td> 
      return(
        <>
        {totalDisplay}
        </>
      )

  }
 

  
}

export default TeamStandingsTotal